import exceljs from "exceljs";
import fs from "file-saver";
import { createdAtToUTC } from "../../utils/date";
import {XLSX_HEADERS_CONFIG} from "./utils/xlsxHeadersConfig.js";

export const convertDateFormat = (timestamp) => {
    if(!timestamp) return "";
    const dateObject = new Date(timestamp);

    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
    const day = dateObject.getDate().toString().padStart(2, '0');
    const hours = dateObject.getHours().toString().padStart(2, '0');
    const minutes = dateObject.getMinutes().toString().padStart(2, '0');
    const seconds = dateObject.getSeconds().toString().padStart(2, '0');

    const newDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    timestamp = newDate;
    return timestamp;
}

export function getXLSXHeader(serviceName) {
    return XLSX_HEADERS_CONFIG[serviceName] || [];
}

export function getXLSXRow(serviceName, document, worksheet) {
    switch (serviceName) {
        case "transactions":
            const services = document?.service_statuses || [];
            const startRow = worksheet.rowCount + 1;
            
            services.sort((a, b) => {
              const dateA = new Date(a?.created_at);
              const dateB = new Date(b?.created_at);
              return dateA - dateB;
            });

            services.forEach((service) => {
                worksheet.addRow({
                    person_id: document?.person_id,
                    flow_id: document?.flow_id,
                    service_name: service?.session_result?.service_name,
                    service_status: service?.session_result?.service_status,
                    error_code: service?.session_result?.error_code,
                    session_status: service?.session_status,
                    // created_at_log: convertDateFormat(service?.session_result?.created_at),
                    created_at: convertDateFormat(service?.created_at),
                    // started_at: convertDateFormat(service?.session_result?.start_time),
                    ended_at: convertDateFormat(service?.updated_at),
                    frontend_session_status: service?.frontend_session_status,
                });
            });

            const endRow = worksheet.rowCount;

            worksheet.mergeCells(`A${startRow}:A${endRow}`); // person_id
            worksheet.mergeCells(`B${startRow}:B${endRow}`); // flow_id
            break;
        
        case "statistics":
            worksheet.addRow({
                total_count: document?.total_count,
                started_count: document?.started_count,
                created_count: document?.created_count,
                ended_count: document?.ended_count,
                failed_count: document?.failed_count,
            })
            break;
        case "signing_sessions":
            worksheet.addRow({
                person_id: document?.person_id,
                flow_id: document?.flow_id,
                service_name: document?.service_name,
                action: document?.result?.action,
                session_id: document?.session_id,
                session_status: document?.session_status,
                error_code: document?.result?.error_code,
                error_message: document?.result?.error_msg,
                created_at: convertDateFormat(document?.created_at),
            });
            break;
        case "signing_statistics":
            worksheet.addRow({
                success_unique_flows: document?.any_success_unique_flows,
                total_sessions: document?.success_sessions + document?.failed_sessions,
                success_sessions: document?.success_sessions,
                failed_sessions: document?.failed_sessions,
            });
            break;
        default:
            console.log("default");
    }
}


export function buildXLSX(serviceName, rawData, statistics) {

    const workbook = new exceljs.Workbook();
    const firstPage = "statistics";
    const secondPage = "transactions";
    const thirdPage = "signing_sessions";
    const fourthPage = "signing_statistics";

    const worksheet = workbook.addWorksheet(firstPage);
    worksheet.columns = getXLSXHeader(firstPage);
    getXLSXRow(firstPage, statistics.general, worksheet);

    const worksheet2 = workbook.addWorksheet(secondPage);
    worksheet2.columns = getXLSXHeader(secondPage);
    rawData.transactions.forEach((transaction) => {
      getXLSXRow(secondPage, transaction, worksheet2);
    });

    const worksheet3 = workbook.addWorksheet(thirdPage);
    worksheet3.columns = getXLSXHeader(thirdPage);
    rawData.signing_sessions.forEach((session) => {
      getXLSXRow(thirdPage, session, worksheet3);
    });

    const worksheet4 = workbook.addWorksheet(fourthPage)
    worksheet4.columns = getXLSXHeader(fourthPage);
    getXLSXRow(fourthPage, statistics.signings, worksheet4)

    return workbook.xlsx.writeBuffer();
}

export function getBuffer(serviceName, rawData, fileExtension, statistics) {
    if (fileExtension === "xlsx") {
        return buildXLSX(serviceName, rawData, statistics);
    }
    return null;
}

export function getMimeType(fileExtension) {

    const mimeType = {
        "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    };

    return mimeType[fileExtension];
}

export function saveFile(buffer, filename, mimeType) {
    const blob = new Blob([buffer], { type: mimeType });
    fs.saveAs(blob, filename);
}